export const RecordAuctionModal = ({ handleCancel, handleConfirm }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div
        style={{
          maxWidth: "560px",
          backgroundImage: "none",
        }}
        className="schedule-form-wrapper"
      >
        <div
          style={{
            position: "relative",
          }}
          className="schedule-form-header"
        >
          <p>Record Auction Sales</p>
        </div>

        <div
          style={{
            width: "100%",
            padding: "32px  16px",
            position: "relative",
            maxHeight: "80vh",
            overflowY: "scroll",
          }}
          className="sale-form-container"
        >
          <div>
            <p
              style={{
                color: "#282828",
              }}
            >
              <span
                style={{
                  fontWeight: "600",
                  paddingRight: "8px",
                }}
              >
                Suit number:
              </span>
              ID/ADR/1470/2020
            </p>
          </div>

          <div className="sale-container">
            <div className="schedule-input-wrapper notice-time-date-wrapper">
              <div style={{ width: "100%" }} className="sale-location-wrapper">
                <label htmlFor="judgeDebt">Judgment Debt *</label>
                <input type="text" id="judgeDebt" placeholder="0.00 NGN" />
              </div>
            </div>
          </div>

          <div className="auction-checkbox-wrapper">
            <label>
              <input type="radio" name="commission" />
              <p className="checkbox-title">Movable Property</p>
              <p className="checkbox-description">3.5% Government commission</p>
            </label>
            <label>
              <input type="radio" name="commission" />
              <p className="checkbox-title">Immovable Property</p>
              <p className="checkbox-description">3.5% + 2.5% commission</p>
            </label>
          </div>
          <div className="sale-container">
            <div className="sale-schedule-wrapper">
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Auctioned Item
              </p>
              <div className="sale-location-wrapper">
                <label htmlFor="description">Item Description *</label>
                <input
                  type="text"
                  id="description"
                  placeholder="Describe the item sold"
                />
              </div>
              <div className="sale-location-wrapper">
                <label htmlFor="amount">Sale Amount </label>
                <input type="number" id="amount" placeholder="0.00 NGN" />
              </div>
              <div className="sale-location-wrapper">
                <label htmlFor="winnersName">Winner's Name *</label>
                <input
                  type="text"
                  id="winnersName"
                  placeholder="Enter winner’s name"
                />
              </div>
              <div className="sale-location-wrapper">
                <label htmlFor="winnersContact">Winner's Contact *</label>
                <input
                  type="text"
                  id="winnersContact"
                  placeholder="Enter winner’s phone number or email"
                />
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "0px",
              justifyContent: "flex-end",
            }}
            className="assign-case-button-group"
          >
            <button
              style={{
                maxWidth: "132px",
              }}
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              style={{
                maxWidth: "224px",
              }}
              onClick={handleConfirm}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
